export default function getPermissionsReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'GET_PERMISSIONS_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'GET_PERMISSIONS_ERROR':
      return {...state, ...{error: action.error}};

    case 'GET_PERMISSIONS_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}